/** Default empty expense item for forms */
export const DEFAULT_EXPENSE_ITEM = {
  description: '',
  qty: 0,
  unit: '',
  price: 0,
  tax: 0,
  taxAmount: 0,
  total: 0,
} as const;
